import { render, staticRenderFns } from "./SchoolOrderList.vue?vue&type=template&id=52914b82&scoped=true"
import script from "./SchoolOrderList.vue?vue&type=script&lang=js"
export * from "./SchoolOrderList.vue?vue&type=script&lang=js"
import style0 from "./SchoolOrderList.vue?vue&type=style&index=0&id=52914b82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52914b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52914b82')) {
      api.createRecord('52914b82', component.options)
    } else {
      api.reload('52914b82', component.options)
    }
    module.hot.accept("./SchoolOrderList.vue?vue&type=template&id=52914b82&scoped=true", function () {
      api.rerender('52914b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolOrder/SchoolOrderList.vue"
export default component.exports